export const StartupField = [
    // Original categories (deduplicated)
    "Advanced Hardware & Technology",
    "Agritech",
    "AI",
    "Clean Tech",
    "Consumer Services",
    "Ecommerce",
    "Edtech",
    "Enterprise Services",
    "Enterprise Tech",
    "Fintech",
    "Foodtech",
    "Health Tech",
    "Logistics",
    "Media & Entertainment",
    "Real Estate Tech",
    "Travel Tech",
    "Web3",
    
    // Newly added categories (10+)
    "SaaS (Software as a Service)",
    "Biotechnology",
    "Green Energy",
    "Social Media",
    "Marketplace",
    "IoT (Internet of Things)",
    "Cybersecurity",
    "Robotics",
    "Augmented Reality (AR)",
    "Space Technology",
    "Gaming & Esports",
    "PropTech (Property Technology)",
    "ClimateTech",
    "Nanotechnology",
    "Quantum Computing",
];